module.exports = __webpack_public_path__ + "static/assets/bf00a442544b2c5cc7b2f63d84a1c4bc.svg";